import { render, staticRenderFns } from "./edit-icon.vue?vue&type=template&id=9148dfb8&scoped=true&"
import script from "./edit-icon.vue?vue&type=script&lang=js&"
export * from "./edit-icon.vue?vue&type=script&lang=js&"
import style0 from "./edit-icon.vue?vue&type=style&index=0&id=9148dfb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9148dfb8",
  null
  
)

export default component.exports